import type { JobStatus } from '../../api/types'

/**
 * How each backend job status is worded on screen.
 *
 * Keyed by the generated union, so a new pipeline step added server-side breaks
 * the build here instead of rendering a raw identifier like
 * "generating_crm_interpretation" at the user.
 */
export const JOB_STATUS_LABEL: Record<JobStatus, string> = {
  queued: 'Queued',
  extracting_text: 'Reading the transcript',
  analysing_extractor: 'Finding the signals',
  validating_thoughts: 'Checking the evidence',
  generating_crm_interpretation: 'Writing the summary',
  updating_deal_state: 'Updating the deal',
  completed: 'Done',
  failed: 'Failed',
}

/** The in-flight steps, in order. Terminal states are not steps. */
export const JOB_STEPS: readonly JobStatus[] = [
  'queued',
  'extracting_text',
  'analysing_extractor',
  'validating_thoughts',
  'generating_crm_interpretation',
  'updating_deal_state',
]
